import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar Seleção", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_busca_geral = _resolveComponent("busca-geral")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_card = _resolveComponent("card")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    centered: "",
    width: 1300,
    "wrap-class-name": "ss-modal-cadastros",
    title: _ctx.props.titulo,
    maskClosable: false
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmar && _ctx.confirmar(...args)))
        }, _hoisted_2)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_busca_geral, {
            empresas: _ctx.telaBase.empresasSelecionadas,
            ordenacao: _ctx.gradeBase.ordenacaoSelecionada,
            "onUpdate:ordenacao": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.gradeBase.ordenacaoSelecionada) = $event)),
            buscaRapida: _ctx.state.buscaRapida,
            "onUpdate:buscaRapida": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.buscaRapida) = $event)),
            buscaAvancada: _ctx.gradeBase.buscaAvancada,
            "onUpdate:buscaAvancada": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.gradeBase.buscaAvancada) = $event)),
            onBuscarDados: _ctx.buscarProdutos
          }, null, 8, ["empresas", "ordenacao", "buscaRapida", "buscaAvancada", "onBuscarDados"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_card, { titulo: "Produtos" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_table, {
                columns: _ctx.state.colunas.filter(item => item.visible),
                "data-source": _ctx.state.produtos,
                rowKey: "codigo",
                pagination: false,
                loading: _ctx.telaBase.carregando,
                scroll: { y: _ctx.state.windowHeight },
                "row-selection": { selectedRowKeys: _ctx.gradeBase.codigosSelecionados, onChange: _ctx.onSelectChange },
                size: "small"
              }, {
                bodyCell: _withCtx(({ column, record, text }) => [
                  (column.customRenderRow === _ctx.ECustomRenderRow.TagAtivo)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        class: _normalizeClass(record.ativo === false ? 'ss-tag-vermelho' : 'ss-tag-verde')
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(record.ativo === true ? 'Ativo' : 'Inativo'), 1)
                        ]),
                        _: 2
                      }, 1032, ["class"]))
                    : (column.customRenderRow === _ctx.ECustomRenderRow.TagAtiva)
                      ? (_openBlock(), _createBlock(_component_a_tag, {
                          key: 1,
                          class: _normalizeClass(record.ativo === false ? 'ss-tag-vermelho' : 'ss-tag-verde')
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(record.ativo === true ? 'Ativa' : 'Inativa'), 1)
                          ]),
                          _: 2
                        }, 1032, ["class"]))
                      : (column.customRenderRow === _ctx.ECustomRenderRow.MascararCPFCNPJ)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(text)), 1))
                        : (column.customRenderRow === _ctx.ECustomRenderRow.MascararTelefoneCelular)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.UtilitarioMascara.mascararTelefoneFixoOuCelular(text)), 1))
                          : _createCommentVNode("", true)
                ]),
                emptyText: _withCtx(() => [
                  _createVNode(_component_mensagem_sem_dados, {
                    resultadoPesquisa: !_ctx.telaBase.carregando,
                    mensagem: _ctx.telaBase.carregando ? 'Buscando informações, por favor aguarde...' : 'Nenhum registro foi encontrado com estes filtros!'
                  }, null, 8, ["resultadoPesquisa", "mensagem"])
                ]),
                _: 1
              }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}